import React, {FunctionComponentElement} from 'react';
import ReactDOM from 'react-dom';
import './index.css';
// import App from './App';
import * as serviceWorker from './serviceWorker';

import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/functions';
import firebase_config from './components/Firebase/config';

import * as jotoTypes from "./api/joto-types";
import Joto, {JotoCallbacksBase} from "./api/joto";

import {Navigation} from './components/Navigation'; 
import {ProfilePage} from './components/profile/ProfilePage'; 
import {OverviewPage} from "./components/overview/OverviewPage";
import {SearchProjects} from "./components/search-projects/SearchProjects";

import {JotoUIApi} from "./joto-ui-api";


import {HandleIndexRoutes} from "./components/handle-index-routes";

import ReactNotification from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import {SelectedProjectView} from "./components/projects/SelectedProjectView";

import * as env from "./env";

import * as log from 'loglevel';

const logger = log.getLogger('index.tsx');
logger.setLevel(env.logLevel);

firebase.initializeApp(firebase_config);

const db = firebase.database();

//ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

function createReduxRehydratedPromiseFn() {
    let fn;
    // noinspection JSUnusedLocalSymbols
    const p = new Promise<void>((resolve, reject) => {
        fn = resolve;
    });
    // noinspection JSUnusedAssignment
    return {p, fn};
}

const {p: reduxRehydratedPromise, fn: initFn} = createReduxRehydratedPromiseFn();

const jotoUIApi = new JotoUIApi(true, initFn);

class JotoCallbacks extends JotoCallbacksBase {

    userLoginHappened(userData: jotoTypes.UserData) {
        jotoUIApi.login(userData.uid);
        // store.dispatch({'type': 'login', 'value': userData.uid});
    }

    userLogoutHappened() {
        jotoUIApi.logout();
        // store.dispatch({type: 'logout'});
    }

    profileDataReceived(profiles: jotoTypes.ProfilePublic[]) {
        logger.debug('userProfileDataReceived : ' + JSON.stringify(profiles));
        if(joto.userData != null) {
            const uid = joto.userData.uid;
            const profile = profiles.find((p) => p.uid === uid);
            if(profile)
                this.userProfileDataReceived(profile);
            else
                this.userProfileDataReceived(null);
        }
    }

    userProfileDataReceived(profile: jotoTypes.ProfilePublic | null) {
        logger.debug('userProfileDataReceived : ' + JSON.stringify(profile));
        jotoUIApi.updateProfile(profile);
        // store.dispatch({'type': 'updateProfile', 'value': profile});
    }

    projectDataReceived(projects: jotoTypes.Projects) {
        logger.debug('projectDataReceived : ' + JSON.stringify(projects));
        jotoUIApi.updateGlobalProjectList(projects);
        // store.dispatch({type: 'updateGlobalProjectList', value: projects});
    }

    ownProjectDataReceived(projects: jotoTypes.Project[]) {
        logger.debug('ownProjectDataReceived : ' + JSON.stringify(projects));
        // store.dispatch({type: 'updateOwnProjectList', value: projects});
        jotoUIApi.updateOwnProjectList(projects);
    }

    singleProjectUpdateHappened(project: jotoTypes.Project) {
        jotoUIApi.singleProjectUpdate(project);
    }
}

const joto = new Joto(db, new JotoCallbacks());
jotoUIApi.store.getState().joto = joto;

function fnTabSelectClickHandler(e : MouseEvent) {
    const t = e.target as HTMLElement;
    if (t.tagName.toLowerCase() === 'a') {
        const target_id = t.dataset.target;
        if (target_id === undefined || !target_id || target_id === '')
            return;

        jotoUIApi.navTabSelect(target_id);
    }
}

function fnCreateProjectClickHandler(e: MouseEvent, joto: Joto) {
    const t = e.target as HTMLElement; 
    if (t.tagName.toLowerCase() === 'a'){
        logger.debug(`userData: ${JSON.stringify(joto.userData)}`); 
        if (joto.userData){
            jotoUIApi.navTabSelect('main-profile'); 
        } else {
            joto.displayGuiLogin(window); 
        }
    }
}




let fnNavbarSupportedContentShow_currentValue : string | null = null;
function fnNavbarSupportedContentShow() {
    let previousValue = fnNavbarSupportedContentShow_currentValue;
    fnNavbarSupportedContentShow_currentValue = jotoUIApi.store.getState().ui.selectedNavTab;

    if (previousValue !== fnNavbarSupportedContentShow_currentValue) {
        const target_id = fnNavbarSupportedContentShow_currentValue;

        const target_element = document.getElementById(target_id);

        // find all div children of main element with class tab-pane
        const main_element = document.getElementsByTagName("MAIN")[0];
        //const tab_pane_element_list = main_element.querySelectorAll(".tab-pane");
        const tab_pane_active_element = main_element.querySelectorAll(".tab-pane.active")[0];
        if(tab_pane_active_element && (tab_pane_active_element.id === target_id)) {
            // do nothing
            return;
        } else if (tab_pane_active_element) {
            tab_pane_active_element.classList.toggle("active");
        }
        if(target_element) {
            target_element.classList.toggle("active");
        }
    }
}
window.fnNavbarSupportedContentShow = fnNavbarSupportedContentShow;

// noinspection JSUnusedLocalSymbols
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const fnNavbarSupportedContentShow_unsubscribe = jotoUIApi.store.subscribe(fnNavbarSupportedContentShow);


function renderOrHydrate(reactElement : FunctionComponentElement<any>, domMountPoint : HTMLElement | null) {
    if(domMountPoint) {
        if (domMountPoint.hasChildNodes()) {
            logger.debug(`hydrate ${domMountPoint.id}`);
            ReactDOM.hydrate(reactElement, domMountPoint);
        } else {
            logger.debug(`render ${domMountPoint.id}`);
            ReactDOM.render(reactElement, domMountPoint);
        }
    }
}

let loadEventInitFn;
// noinspection JSUnusedLocalSymbols
const loadEventInitPromise = new Promise<void>((resolve, reject) => {
    loadEventInitFn = resolve;
});
if(loadEventInitFn)
    window.addEventListener("load", loadEventInitFn);

logger.info(process.env.NODE_ENV);

(async () => {
    logger.info("Check if all pre-requisites are loaded: reduxRehydratedPromise, loadEventInitPromise");
    await Promise.all([reduxRehydratedPromise, loadEventInitPromise]);
    logger.info("All pre-requisites are loaded: reduxRehydratedPromise, loadEventInitPromise");
    logger.info('checking log levels debug, info, warn and error; and will print the env.project_base_url.');
    logger.debug('debug: ' + env.project_base_url);
    logger.info('info: ' + env.project_base_url);
    logger.warn('warn: ' + env.project_base_url);
    logger.error('error: ' + env.project_base_url);

    await init();
})();


// gravatar profile image
// https://steemit.com/firebase/@dennisalund/create-user-data-for-new-firebase-auth-accounts
// https://github.com/sindresorhus/gravatar-url
async function init() {
    const content = document.getElementById('navbarSupportedContent');
    const searchLinkButton = document.getElementById('searchLinkButton'); 
    const profileLinkButton = document.getElementById('profileLinkButton'); 
    const findandoLogo = document.getElementById('findando'); 
    if(content)
        content.addEventListener('click', fnTabSelectClickHandler);
    if (searchLinkButton)
        searchLinkButton.addEventListener('click', fnTabSelectClickHandler); 
    if (findandoLogo)
        findandoLogo.addEventListener('click', fnTabSelectClickHandler)
    if (profileLinkButton)
        profileLinkButton.addEventListener('click', function(e){fnCreateProjectClickHandler(e, joto)})
    //TODO: add Click handler for profileLinkButton
    fnNavbarSupportedContentShow();

    const r = await joto.login();
    await Promise.all(r);
    logger.debug('result of awaited login : ' + JSON.stringify(r));

    renderOrHydrate(jotoUIApi.wrapRedux(<ReactNotification/>), document.getElementById('react-notifications-component'));

    renderOrHydrate(jotoUIApi.wrapRedux(<Navigation joto={joto}/>), document.getElementById('navbarSupportedContent'));

    renderOrHydrate(jotoUIApi.wrapRedux(<ProfilePage joto={joto} jotoui={jotoUIApi}/>), document.getElementById('main-profile'));

    // renderOrHydrate(jotoUIApi.wrapRedux(<ProjectEditPage joto={joto} jotoui={jotoUIApi}/>), document.getElementById('main-project'));

    renderOrHydrate(jotoUIApi.wrapRedux(<OverviewPage joto={joto} jotoui={jotoUIApi}/>), document.getElementById('main-project-overview-bottom'));

    renderOrHydrate(jotoUIApi.wrapRedux(<SearchProjects joto={joto} jotoui={jotoUIApi}/>), document.getElementById('search-projects'));

    //renderOrHydrate(jotoUIApi.wrapRedux(<DivProjectDetailPage joto={joto} jotoui={jotoUIApi}/>), document.getElementById('main-selected-project-view'));

    // http://localhost:3000/index.html?uid=LTGgFOBshcRQDutpH35QFWyNzz02&pid=00
    renderOrHydrate(jotoUIApi.wrapRedux(<HandleIndexRoutes jotoui={jotoUIApi}/>), document.getElementById('handle-routes'));

    renderOrHydrate(jotoUIApi.wrapRedux(<SelectedProjectView joto={joto} jotoui={jotoUIApi} closeElement={false} likeElement={true} modal={true}/>), document.getElementById('main-selected-project-modal-view-mount'));
    // main-selected-project-modal-view-mount

    // jotoUIApi.addNotification('Title', 'Message Text blah blah blah blah', "default", 7000);

}

const dummybutton = document.getElementById("dummybutton");
if(dummybutton) {
    dummybutton.addEventListener("click", function() {
        (window as any).$('#main-selected-project-modal-view').modal('show');
    });
}



